import { render, staticRenderFns } from "./payDeposit.vue?vue&type=template&id=b8785896&scoped=true"
import script from "./payDeposit.vue?vue&type=script&lang=js"
export * from "./payDeposit.vue?vue&type=script&lang=js"
import style0 from "./payDeposit.vue?vue&type=style&index=0&id=b8785896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8785896",
  null
  
)

export default component.exports